module.exports = __webpack_public_path__ + "static/media/iPadPortrait.67750a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iPadPortrait.png
// module id = 120
// module chunks = 0